import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = ["media", "srcset"];
var _hoisted_2 = ["media", "srcset"];
var _hoisted_3 = ["srcset"];
var _hoisted_4 = ["src", "srcset", "alt", "width", "height", "loading"];
import { computed, onMounted, useTemplateRef } from "vue";
import { handleLazyImage } from "./lazy";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Picture',
    props: {
        picture: { type: Object, required: true },
        mobilePicture: { type: Object },
        mobileMaxWidth: { type: Number, default: 450 },
        alt: String,
        aspect: Boolean,
        class: { type: String, default: "" },
        fill: Boolean,
        lazy: { type: Boolean, default: undefined },
        width: Number,
        height: Number,
    },
    setup: function (__props) {
        var props = __props;
        var media = computed(function () { return "(max-width: ".concat(props.mobileMaxWidth, "px)"); });
        var img = useTemplateRef('img');
        var style = computed(function () {
            if (!props.aspect) {
                return undefined;
            }
            return "aspect-ratio: ".concat((props.picture.width / props.picture.height).toPrecision(4));
        });
        function makeSrcSet(src) {
            return "".concat(src.loDPI, ", ").concat(src.hiDPI, " 2x");
        }
        onMounted(function () {
            handleLazyImage(img.value);
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("picture", {
                class: _normalizeClass({ 'img--fill': __props.fill, lazy: __props.lazy }),
                style: _normalizeStyle(style.value)
            }, [
                (__props.mobilePicture)
                    ? (_openBlock(), _createElementBlock("source", {
                        key: 0,
                        type: "image/webp",
                        media: media.value,
                        srcset: makeSrcSet(__props.picture.webp)
                    }, null, 8 /* PROPS */, _hoisted_1))
                    : _createCommentVNode("v-if", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (__props.mobilePicture)
                    ? (_openBlock(), _createElementBlock("source", {
                        key: 1,
                        type: "image/jpeg",
                        media: media.value,
                        srcset: makeSrcSet(__props.picture.jpeg)
                    }, null, 8 /* PROPS */, _hoisted_2))
                    : _createCommentVNode("v-if", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("source", {
                    type: "image/webp",
                    srcset: makeSrcSet(__props.picture.webp)
                }, null, 8 /* PROPS */, _hoisted_3),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("img", {
                    src: __props.picture.jpeg.loDPI,
                    srcset: "".concat(__props.picture.jpeg.hiDPI, " 2x"),
                    alt: __props.alt,
                    class: _normalizeClass(__props.class),
                    width: __props.width,
                    height: __props.height,
                    loading: __props.lazy ? 'lazy' : __props.lazy === false ? 'eager' : undefined,
                    ref_key: "img",
                    ref: img
                }, null, 10 /* CLASS, PROPS */, _hoisted_4)
            ], 6 /* CLASS, STYLE */));
        };
    }
});
